<template>
    <div id="login-modal" class="modal">
        <div class="modal-content">
            <div class="w-100 text-right">
                <button class="btn-transparent muted-color font-regular" data-close="login-modal">
                    <i class="fa-solid fa-circle-xmark"></i>
                </button>
            </div>
            <p class="text-center" v-if="srcImage && srcImage!== ''"><img :src="srcImage" class="logo-sm"></p>
            <p class="">¡Bienvenido!</p>
            <small class="mt-1">Lorem ipsum dolor, sit amet consectetur adipisicing.</small>
            <form @submit="handleSubmit($event)">
                <input name="email" v-model="form.email" :class="['custom-input-transparent my-1', {'is-invalid': formErrors.includes('email')}]" placeholder="Correo electrónico">
                <input type="password" name="password" v-model="form.password" :class="['custom-input-transparent my-1', {'is-invalid': formErrors.includes('password')}]" placeholder="Contraseña">
                <div v-if="errors">
                    <p class="my-1 font-sm danger-color" v-for="error in errors"> {{error[0]}} </p>
                </div>
                <p class="my-1 font-sm danger-color" v-if="error">{{error}}</p>
                <div class="display-flex mt-1">
                    <div class="form-group-row ml-1">
                        <input id="chbox-remember-me" type="checkbox" class="custom-checkbox">
                        <label for="chbox-remember-me" class="font-sm">Recordarme</label>
                    </div>
                    <a class="font-sm muted-color" href="#">Forgot Password?</a>
                </div>
                <button :disabled="isLoggin" class="btn-login my-1">INICIO DE SESIÓN</button>

                <a v-if="showGoogle === 'true'" href="/api/login/google/redirect" class="google-btn w-100">
                    <img src="https://developers.google.com/identity/images/g-logo.png" alt="Google logo">
                    Iniciar sesión con Google
                </a>
            </form>
            <p class="font-sm text-center muted-color">¿Aún no tienes cuenta? <a class="danger-color font-semibold" href="/register">Registrate Gratis</a></p>
        </div>
    </div>
</template>
<script>
import apiClient from '../../services/apiClient';

export default {
    name: "login-modal",
    props: {
        srcImage: {
            type: String,
            default: ''
        },
        showGoogle: String
    },
    data() {
        return {
            errors: [],
            error: '',
            form: {
                email: '',
                password: ''
            },
            formErrors: [

            ],
            isLoggin: false
        }
    },
    methods: {
        handleSubmit(event) {
            event.preventDefault();
            this.validateForm();
            if(this.formErrors.length > 0) return;
            this.login(this.form);
        },
        validateForm (){
            this.errors = [];
            this.error = '';
            this.formErrors = [];
            if (this.form.email === '') this.formErrors.push('email');
            if (this.form.password === '') this.formErrors.push('password');
        },
        login(formData) {
            this.isLoggin = true;

            apiClient.post('/api/auth/login', formData)
            .then((response) => {
                const {data} = response
                if(data.access_token !== undefined) {
                    localStorage.setItem('access_token', data.access_token);
                    sessionStorage.setItem('ui', JSON.stringify({clientModal: true}))
                    let redirect_to = sessionStorage.getItem('redirect_to') ?? '/order/view';
                    sessionStorage.removeItem('redirect_to');
                    location.href = redirect_to;
                    return;
                }

                this.isLoggin = false;
                this.errors = data.errors;
                this.error = data.error ?? '';
            })
            .catch((e) => {
                this.isLoggin = false;
                const {error} = e.response.data;
                this.error = (error && typeof error === 'string') ? error : 'Error al iniciar sesión';
            });
        },
        loginWithGoogle() {
           window.location.href = '/api/login/google/redirect'
        }
    }
}
</script>

<style>
.google-btn {
  justify-content: center;
  display: inline-flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 10px 15px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #444;
  border-radius: 4px;
  text-decoration: none;
  transition: box-shadow 0.2s;
}

.google-btn:hover {
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.google-btn img {
  width: 20px;
  margin-right: 10px;
}

</style>